
import React from 'react'

import './ColorCodeOption.scss'

interface ColorCodeOptionProps {
  name: string;
  color: string;
  selected: boolean;
  onClick: () => void;
  onEdit: (e: any) => void;
}

const ColorCodeOption = ({ name, color, selected, onClick, onEdit }: ColorCodeOptionProps) => {

  return (
    <div className={`color-code-option ${selected ? 'selected' : ''}`}>
      <button
        className="select"
        onClick={() => onClick()}
      >
        <span className="color" style={{ backgroundColor: color }}></span>
        <span className="code bold">{name}</span>
      </button>
      <div className="separator"></div>
      <button
        className='action-button cursor-pointer'
        onClick={onEdit}
      >
        <i className='fas fa-fw fa-ellipsis-v'></i>
      </button>
    </div>
  )
}

export default ColorCodeOption
